// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4643":"7874cc49fdfa42c2","8957":"9675a6edc0af9a00"}[chunkId] + ".css";
};